module.exports = __webpack_public_path__ + "img/yinlian.594eba13.png";